const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/dashboard',
}

export const paths = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  page404: '/404',
  auth: {
    login: `${ROOTS.AUTH}/login`,
    register: `${ROOTS.AUTH}/register`,
    forgotPassword: `${ROOTS.AUTH}/forgot-password`,
    newPassword: `${ROOTS.AUTH}/new-password`,
    verify: `${ROOTS.AUTH}/verify`,
  },
  // DASHBOARD
  dashboard: {
    root: `${ROOTS.DASHBOARD}/budgets`,
    user: `${ROOTS.DASHBOARD}/users`,
    clients: `${ROOTS.DASHBOARD}/clients`,
    packages: `${ROOTS.DASHBOARD}/packages`,
    budgets: {
      root: `${ROOTS.DASHBOARD}/budgets`,
      create: `${ROOTS.DASHBOARD}/budgets/create`,
      preview: (id: string) => `${ROOTS.DASHBOARD}/budgets/${id}/preview`,
    },
    hostings: `${ROOTS.DASHBOARD}/hostings`,
    hostingBudgets: {
      root: `${ROOTS.DASHBOARD}/hosting-budgets`,
      create: `${ROOTS.DASHBOARD}/hosting-budgets/create`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/hosting-budgets/${id}/edit`,
      createFromBudget: (budgetId: string) =>
        `${ROOTS.DASHBOARD}/hosting-budgets/create?linkedBudget=${budgetId}`,
    },
    kanban: `${ROOTS.DASHBOARD}/kanban`,
    tasks: `${ROOTS.DASHBOARD}/tarefas`,
    reports: `${ROOTS.DASHBOARD}/reports`,
    reportsBudgets: `${ROOTS.DASHBOARD}/reports/orcamentos`,
    settings: `${ROOTS.DASHBOARD}/settings`,
  },
}
